export default __webpack_public_path__ + "static/media/QBDevil.6f74c48c.gif";